import React, { useState, useEffect, useContext, useRef } from "react";
import { Link } from "react-router-dom";
import * as FaIcons from "react-icons/fa";
//import * as FiIcons from "react-icons/fi";
//import { IconContext } from 'react-icons';
import "./Notifications.css";
import NotificationsNoneIcon from "@mui/icons-material/NotificationsNone";
import { Avatar, Box, Typography } from "@mui/material";
import api from "../../utils/api";
import CancelIcon from "@mui/icons-material/Cancel";
import CircleNotificationsIcon from "@mui/icons-material/CircleNotifications";
import { format } from "timeago.js";
import { useDispatch, useSelector } from "react-redux";
import ClearIcon from "@mui/icons-material/Clear";

function Notifications({
  hideNotifications,
  notifications,
  setUnreadNotificationCount,
}) {
  const [isMobile, setIsMobile] = useState(false);
  const scrollRef = useRef();
  const userstate = useSelector((state) => state.loginUserReducer);
  const { currentUser } = userstate;

  //   useEffect(() => {
  //     //console.log("opening notification...");
  //     //console.log("notifications in Noti?>>", notifications);

  //     //updating read status
  //     notifications.forEach((notif) => {
  //       const data = {
  //         notificationId: notif._id,
  //         read: true,
  //       };
  //       api.put(`/notifications/update`, data);
  //     });
  //     setUnreadNotificationCount(0);
  //   }, [notifications]);
  useEffect(() => {
    console.log("notifications", notifications);
    notifications.map((n) => {
      if (!n?.isReceived) {
        api
          .put(`/notifications/update-status/${n?._id}`)
          .then((res) => console.log())
          .catch((err) => console.log);
      }
    });
  }, [notifications]);
  useEffect(() => {
    scrollRef.current?.scrollIntoView({ behaviour: "smooth" });
  }, [notifications]);
  return (
    <Box className="notif_container">
      <Box bgcolor="white" className="notifications_box">
        <header>
          <Typography variant="h6" sx={{ fontWeight: "600", padding: "10px" }}>
            {" "}
          </Typography>
          <ClearIcon onClick={() => hideNotifications()} />
        </header>
        {notifications?.length > 0 ? (
          <section className="scroll">
            {notifications
              ?.sort(function (a, b) {
                return new Date(b.updatedAt) - new Date(a.updatedAt);
              })
              ?.map((notification) => (
                <Box className="notification" bgcolor="white">
                  <CircleNotificationsIcon />
                  <p>{notification.text}</p>
                  <span>{format(notification?.createdAt)}</span>
                </Box>
              ))}
          </section>
        ) : (
          <>
            <br />
            <p>&nbsp; no notifications</p>
          </>
        )}
      </Box>
    </Box>
  );
}

export default Notifications;
